<template>
    <nav class="panel">
        <p class="panel-heading">
            News feed
        </p>
        <VuePerfectScrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHandle">
            <router-link v-for="post in threads" :to="'/single/' + post.lot_id" class="panel-block is-active">
                <span class="panel-icon has-text-danger">
                    <i class="fas fa-language" v-if="post.translation_id > 0"></i>
                    <i class="fas fa-comments" v-else></i>
                </span>
                {{ post.user.name }}  <small>@ {{ post.created_at }} [{{ post.lot.bid }}] {{ post.lot.auction_name }}</small>
            </router-link>
        </VuePerfectScrollbar>
    </nav>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import commentsApi from './../../api/apiComments.js'
    export default {
        components: {
            VuePerfectScrollbar: VuePerfectScrollbar
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60
                },
                threads: []
            }
        },
        mounted () {
            commentsApi
                .getAllThreadsRequest()
                .then((response) => {
                    this.threads = response.data
                })
                .catch(error => console.log(error))
        },
        methods: {
            scrollHandle(evt) {

            }
        },
    }
</script>

<style scoped>
    .scroll-area {
        max-height: 208px;
    }
    small {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/News.vue